import { API, DEFAULT_API_VERSION } from '../constants';

const dropFirstSlash = (path: string) =>
    path.startsWith('/') ? path.slice(1) : path;

export const urlBuilder = (
    endpoint: string,
    path: string,
    version: string = DEFAULT_API_VERSION
) => `${API}${dropFirstSlash(endpoint)}/${version}${dropFirstSlash(path)}`;

export const buildSearchParams = (params: Record<string, unknown>): string => {
    if (params === null) return '';
    return Object.keys(params).length
        ? `?${Object.keys(params)
              .map((key, i) => {
                  const param = params[key];
                  if (key && param !== null && param !== undefined) {
                      return `${i > 0 ? '&' : ''}${key}=${params[
                          key
                      ].toString()}`;
                  }

                  return null;
              })
              .filter((entry) => !!entry)
              .join('')}`
        : '';
};
